// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".1d0e9e34934f579b5a69294aeecd6f5d0c721457.chunk.js";
};